import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';

const [VIEW_CHANCE, VIEW_CHANCE_SUCCESS, VIEW_CHANCE_FAILURE] =
  createRequestActionTypes('chance/VIEW_CHANCE');
export const viewChance = createAction(VIEW_CHANCE, (id) => id);
const viewChanceSaga = createRequestSaga(VIEW_CHANCE, chanceApi.getChance);

//활성화된 견적서 확인
const [CHANCE_ESTIMATE_ACTIVE, CHANCE_ESTIMATE_ACTIVE_SUCCESS, CHANCE_ESTIMATE_ACTIVE_FAILURE] =
  createRequestActionTypes('chance/CHANCE_ESTIMATE_ACTIVE');
export const chanceEstimateActive = createAction(CHANCE_ESTIMATE_ACTIVE, (id) => id);
const chanceEstimateActiveSaga = createRequestSaga(CHANCE_ESTIMATE_ACTIVE, chanceApi.getActiveEstimate);

//활성화된 수주 확인
const [CHANCE_ORDER_COUNT, CHANCE_ORDER_COUNT_SUCCESS, CHANCE_ORDER_COUNT_FAILURE] =
  createRequestActionTypes('chance/CHANCE_ORDER_COUNT');
export const chanceOrderCount = createAction(CHANCE_ORDER_COUNT, (id) => id);
const chanceOrderCountSaga = createRequestSaga(CHANCE_ORDER_COUNT, chanceApi.getChanceOrderCount);


const UNLOAD_CHANCE = 'chance/UNLOAD_CHANCE';
export const unloadChance = createAction(UNLOAD_CHANCE);

const SET_CHANCE = 'chance/SET_CHANCE';
export const setChance = createAction(SET_CHANCE, (chance) => chance);


export function* chanceSaga() {
  yield takeLatest(VIEW_CHANCE, viewChanceSaga);
  yield takeLatest(CHANCE_ESTIMATE_ACTIVE, chanceEstimateActiveSaga);
  yield takeLatest(CHANCE_ORDER_COUNT, chanceOrderCountSaga);
}

const initialState = {
  chance: null,
  activeEstimate: null,
  orderCount: null,
  orderInfo: null,
  error: null,
};

const chance = handleActions(
  {
    [VIEW_CHANCE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      chance: data.info,
    }),
    [VIEW_CHANCE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [CHANCE_ESTIMATE_ACTIVE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      activeEstimate: data.info,
    }),
    [CHANCE_ESTIMATE_ACTIVE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [CHANCE_ORDER_COUNT_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      orderCount: data.count,
      orderInfo: data.list,
    }),
    [CHANCE_ORDER_COUNT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [UNLOAD_CHANCE]: () => initialState,
    [SET_CHANCE]: (state, { payload: chance }) => ({
      ...state,
      chance: chance,
    }),

  },
  initialState,
);

export default chance;
